import { render, staticRenderFns } from "./clientDisplayNouSomniII.vue?vue&type=template&id=450a86eb&scoped=true&"
import script from "./clientDisplayNouSomniII.vue?vue&type=script&lang=js&"
export * from "./clientDisplayNouSomniII.vue?vue&type=script&lang=js&"
import style0 from "./clientDisplayNouSomniII.vue?vue&type=style&index=0&id=450a86eb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450a86eb",
  null
  
)

export default component.exports